<div class="article">
  <h1 class="title">{{ project.title }}</h1>
  <div class="project-info">
    <img [src]="project.imageUrl" />
    <div class="basic-info">
      <h2>Timeline</h2>
      <p class="basic-information">{{ project.timeLine }}</p>
      <h2>My Role</h2>
      <p class="basic-information">{{ project.myRole }}</p>
      <h2>Team</h2>
      <p class="basic-information">{{ project.team }}</p>
      <h2>Technology</h2>
      <p class="basic-information">{{ project.technology }}</p>
    </div>
  </div>

  <p [innerHTML]="project.content"></p>
  <div class="button">
    <a [href]="project.buttonUrl" target="_blank"
      ><button>{{ project.buttonText }}</button></a
    >
  </div>
</div>
